import { Component, OnInit, Output, EventEmitter } from "@angular/core";
import { adminGlobal } from "src/app/admin-mmm/adminGlobal";
import { summaryComponent } from "./summary/summary.component";
import { PasswordConfigComponent } from "./passwordConfig/password-config/password-config.component";
import { ResourceRequireComponent } from "./ResourceRequire/ResourceRequire.component";
import { systemReportComponent } from "./systemReport/systemReport.component";
import { PredefinedQueryComponent } from "./PredefinedQuery/PredefinedQuery.component";
import { TandCComponent } from "./TandC/TandC.component";
import { ExpectedLifeComponent } from "./ExpectedLife/ExpectedLife.component";
import { AssetConfigComponent } from "./assetConfig/assetConfig.component";
import { visualizationDataLayerComponent } from "./visualizationDataLayer/visualizationDataLayer.component";
import { NgIf } from "@angular/common";
import { AgencyConfigComponent } from "./agencyConfig/agency.component";
import { NgbNav, NgbNavItem, NgbNavItemRole, NgbNavLinkBase, NgbNavLink, NgbNavContent, NgbNavOutlet } from "@ng-bootstrap/ng-bootstrap";

@Component({
    selector: "sms-administrator",
    templateUrl: "./admin-mmm.component.html",
    styleUrls: ["./admin-mmm.component.scss"],
    standalone: true,
    imports: [NgbNav, NgbNavItem, NgbNavItemRole, NgbNavLinkBase, NgbNavLink, NgbNavContent, AgencyConfigComponent, NgIf, 
      visualizationDataLayerComponent, AssetConfigComponent, ExpectedLifeComponent, TandCComponent, PredefinedQueryComponent, 
      systemReportComponent, ResourceRequireComponent, PasswordConfigComponent, summaryComponent, NgbNavOutlet]
})
export class AdministratorComponent implements OnInit {
  constructor(public adminGlobal: adminGlobal) {}
  @Output() data = new EventEmitter();
  active = 1;
  ngOnInit(): void {
    //console.log("init");
  }

  toggleNavbar(event): void {
    console.log(event.target.id);
  }
  showQueryData($event): void {
    this.data.emit($event);
  }
}
